import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core'

@Component({
    selector: "feature-item",
    templateUrl: './feature-item.template.html',
    styleUrls: ['./feature-item.style.scss']
})

export class FeatureItem implements OnInit {
    @Input() item: any;
    @Input() layout: string;
    protected external_url: string;
    constructor() { }

    ngOnChanges(changes: SimpleChanges) {
    }

    ngOnInit() {
        //console.log(this.item);
        if (this.item.meta['url'] && this.item.meta['target'] && this.item.meta['target'] == "_blank"){
            this.external_url = this.item.meta['url'];
        }
    }


    private get marqueeObjType(): string {
        
        return ((this.item.meta || this.item).obj_type || "").toLowerCase();
    }

    private get marqueeCta(): string {
        return ['video', 'episode'].indexOf(this.marqueeObjType) > -1 ? "play" : this.marqueeObjType;
    }
}





// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/feature-list/feature-item/feature-item.component.ts